import { useContext } from "react";
import { Accordion as AccordionComponent, AccordionItem, AccordionTrigger, AccordionContent } from '@aidkitorg/component-library';
import InterfaceContext from "../Context";
import { safeParse } from "../Util";
import { QuestionProps } from "./Props";
import { useModularMarkdown } from "../Hooks/ModularMarkdown";

export function CollapsibleContent(props: QuestionProps) {
  const context = useContext(InterfaceContext);
  const { heading, content, defaultOpen, headingSize = 'xl' } = safeParse(props.Metadata ?? "{}", {});

  const headingText = typeof heading === 'object' && heading !== null
    ? heading[context.lang] || heading['en'] || ''
    : String(heading || '');

  // Always use the English heading for the stable item identifier so that
  // defaultValue and AccordionItem value match regardless of current language.
  const headingEn = typeof heading === 'object' && heading !== null
    ? heading['en'] || ''
    : String(heading || '');
  const itemValue = headingEn.toLowerCase().replace(/[^a-z0-9\s-]/g, '').trim().replace(/\s+/g, '-').replace(/-+/g, '-') || 'collapsible-content-item';

  const contentMarkdown = useModularMarkdown({
    content: content,
    info: {...props.info, uid: props.uid || 'No UID'},
  });
  // Map heading size to font size: sm = 14px, md = 16px, lg = 20px, xl = 32px (h2)
  const sizeClassMap: Record<string, string> = {
    'sm': 'text-sm',      // 14px
    'md': 'text-base',    // 16px
    'lg': 'text-xl',      // 20px
    'xl': 'text-[32px]',  // 32px (h2)
  };

  const sizeClass = sizeClassMap[headingSize] || sizeClassMap['xl'];

  return <AccordionComponent type="single" defaultValue={defaultOpen ? itemValue : ''}>
    <AccordionItem value={itemValue}>
      <AccordionTrigger className={sizeClass}>{headingText}</AccordionTrigger>
      <AccordionContent>{contentMarkdown}</AccordionContent>
    </AccordionItem>
  </AccordionComponent>;
}
